import styled, { css, CSSProp } from 'styled-components';

import { typography, spacing } from '../theme';
import { headingStyles } from '../theme/variables/typography';

const BaseHeadingStyles = css`
  font-style: normal;
  font-weight: ${typography.fontWeightBold};
  text-rendering: optimizeLegibility;
  margin-bottom: ${spacing.spacing4};
  font-feature-settings: normal;
  font-family: ${typography.fontSecondary};

  + h1,
  + h2,
  + h3,
  + h4,
  + h5,
  + h6 {
    margin-top: ${spacing.spacing6};
  }
`;

// HeadingStyles props ************
//  desktopFontSize: number,
//  desktopLetterSpacing: string,
//  desktopLineHeight: number,
//  margin: string,
//  mobileFontSize: number,
//  mobileLetterSpacing: string,
//  mobileLineHeight: number

export const HeadingStyles: { [key: string]: CSSProp } = {
  h1: css`
    ${BaseHeadingStyles};
    ${headingStyles(
      32,
      typography.letterSpacingXLarge,
      typography.lineHeight1,
      `${spacing.spacing7} 0 ${spacing.spacing5} 0`,
      40,
      typography.letterSpacingXLarge,
      typography.lineHeight12,
    )};
  `,
  h2: css`
    ${BaseHeadingStyles};
    ${headingStyles(
      27,
      typography.letterSpacingXSmall,
      typography.lineHeight13,
      `0 0 ${spacing.spacing3} 0`,
      33,
      typography.letterSpacingMedium,
      typography.lineHeight14,
    )};
  `,
  h3: css`
    ${BaseHeadingStyles};
    ${headingStyles(
      23,
      typography.letterSpacingXSmall,
      typography.lineHeight16,
      `0 0 ${spacing.spacing3} 0`,
      28,
      typography.letterSpacingXSmall,
      typography.lineHeight15,
    )};
  `,
  h4: css`
    ${BaseHeadingStyles};
    ${headingStyles(
      20,
      typography.letterSpacingLarge,
      typography.lineHeight17,
      `0 0 ${spacing.spacing3} 0`,
      24,
      typography.letterSpacingMedium,
      typography.lineHeight17,
    )};
  `,
  h5: css`
    ${BaseHeadingStyles};
    ${headingStyles(
      18,
      typography.letterSpacingSmall,
      typography.lineHeight17,
      `0 0 ${spacing.spacing3} 0`,
      19,
      typography.letterSpacingMedium,
      typography.lineHeight18,
    )};
  `,
  h6: css`
    ${BaseHeadingStyles};
    ${headingStyles(
      16,
      typography.letterSpacingSmall,
      typography.lineHeight17,
      `0 0 ${spacing.spacing3} 0`,
      16,
      typography.letterSpacingMedium,
      typography.lineHeight18,
    )};
  `,
};

export const Heading1 = styled.h1<{
  styledAs?: string;
}>`
  ${HeadingStyles.h1};
  ${(props) => props.styledAs && HeadingStyles[props.styledAs]}
`;

export const Heading2 = styled.h2<{
  styledAs?: string;
}>`
  ${HeadingStyles.h2};
  ${(props) => props.styledAs && HeadingStyles[props.styledAs]}
`;

export const Heading3 = styled.h3<{
  styledAs?: string;
}>`
  ${HeadingStyles.h3};
  ${(props) => props.styledAs && HeadingStyles[props.styledAs]}
`;

export const Heading4 = styled.h4<{
  styledAs?: string;
}>`
  ${HeadingStyles.h4};
  ${(props) => props.styledAs && HeadingStyles[props.styledAs]}
`;

export const Heading5 = styled.h4<{
  styledAs?: string;
}>`
  ${HeadingStyles.h5};
  ${(props) => props.styledAs && HeadingStyles[props.styledAs]}
`;

export const Heading6 = styled.h4<{
  styledAs?: string;
}>`
  ${HeadingStyles.h6};
  ${(props) => props.styledAs && HeadingStyles[props.styledAs]}
`;
